import { Link } from "react-router-dom";
import Container from "../components/layout/Container";
import PageHeader from "../components/layout/PageHeader";
import TextLink from "../components/ui/TextLink";
import { listedProjects } from "../data/site";
import projectMarks from "../components/ui/projectMarks";

export default function ProjectsPage() {
  return (
    <>
      <PageHeader title="Projects" lede="Selected software projects." />
      <Container className="pb-24">
        <ul className="border-t border-[var(--line)]">
          {listedProjects().map((project) => (
            <li key={project.title} className="border-b border-[var(--line)] py-8">
              <div className="grid items-center gap-6 md:grid-cols-12">
                {project.href && project.href !== "/projects" ? (
                  <Link to={project.href} className="project-shot md:col-span-5" aria-label={project.title}>
                    {project.image ? <img src={project.image} alt={project.title} /> : <span className="project-poster" />}
                  </Link>
                ) : (
                  <span className="project-shot md:col-span-5">
                    {project.image ? <img src={project.image} alt={project.title} /> : <span className="project-poster" />}
                  </span>
                )}
                <div className="md:col-span-7">
                  <div className="flex flex-col gap-1 sm:flex-row sm:items-baseline sm:justify-between sm:gap-8">
                    <h2 className="flex items-center gap-3 text-2xl font-medium tracking-tight">
                      {project.title}
                      {project.marks?.length ? (
                        <span className="flex gap-2 text-[var(--accent)]">
                          {project.marks.map((name) => {
                            const Icon = projectMarks[name];
                            return Icon ? <Icon key={name} aria-hidden="true" size={18} /> : null;
                          })}
                        </span>
                      ) : null}
                    </h2>
                    <p className="text-sm font-medium text-[var(--accent)]">{project.category}</p>
                  </div>
                  <p className="mt-4 max-w-2xl leading-relaxed text-[var(--text)]">{project.description}</p>
                  <ul className="mt-4 flex flex-wrap gap-x-4 gap-y-2">
                    {project.tags.map((tag) => (
                      <li key={tag} className="text-sm text-[var(--muted)]">
                        {tag}
                      </li>
                    ))}
                  </ul>
                  <div className="mt-3 flex flex-wrap gap-x-6">
                    {project.href && project.href !== "/projects" ? (
                      <TextLink href={project.href}>View project</TextLink>
                    ) : null}
                    {project.store ? (
                      <TextLink href={project.store} external>
                        Play Store
                      </TextLink>
                    ) : null}
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </Container>
    </>
  );
}
